export interface HonorariumDTO {
    honorarium: number | null;

    nomenclatortype: number | null;
    nomenclatortypedesc: string | null;

    nomenclator: number | null;
    nomenclatorcode: string | null;
    nomenclatordesc: string | null;

    value: number | null;

    billingbyhour: boolean;

    datestart: Date | null;
    dateend: Date | null;
}

export const defaultHonorariumDTO: HonorariumDTO = {
    honorarium: -1, 

    nomenclatortype: -1, 
    nomenclatortypedesc: '',

    nomenclator: -1, 
    nomenclatorcode: '', 
    nomenclatordesc: '', 
    value: 0, 

    billingbyhour: false, 

    datestart: null, 
    dateend: null, 
};
